<template>
  <div id="app">
    <template v-if="!isScreen">
      <layout />
      <UpdateNoticeModal />

      <!-- 首次登录提示 Modal - 一直显示直到密码修改 -->
      <el-dialog
        title="系统提示"
        :visible.sync="showFirstLoginModal"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        center
        append-to-body
      >
        <div style="text-align: center; padding: 20px;">
          <i class="el-icon-warning" style="color: #E6A23C; font-size: 24px; margin-right: 10px;" />
          <span>首次登录需要修改密码</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="goToChangePassword">立即修改密码</el-button>
        </span>
      </el-dialog>

    </template>
    <template v-else>
      <screen-layout />
    </template>
  </div>
</template>

<script>
// import watermark from 'watermark-dom'
import { mapState } from 'vuex'
import Layout from './components/Layout'
import ScreenLayout from './components/ScreenLayout/index.vue'
import { getUserInfoFlag } from '@/api/user'
import store from '@/store'

import UpdateNoticeModal from '@/components/Layout/components/UpdateNoticeModal/index.vue'

export default {
  name: 'App',
  components: {
    Layout,
    ScreenLayout,
    UpdateNoticeModal
  },
  data() {
    return {
      showFirstLoginModal: false
    }
  },
  computed: {
    ...mapState({
      'user': state => state.user
    }),
    // 是否需要菜单和头部布局
    isScreen() {
      return !!this.$route.meta.isScreen
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler(val) {
        // 登录页不检查，避免未授权请求引发 401
        if (this.$route && this.$route.path === '/login') return
        this.checkFirstLogin()

        // if (this.user) {
        //   const name = this.user.name
        //   const email = this.user.email
        //   const str = [name, email].filter(v => v).join('(')
        //   this.$nextTick(() => {
        //     setTimeout(() => {
        //       watermark.init({
        //         watermark_txt: str + ')',
        //         watermark_color: 'black',
        //         watermark_fontsize: '14px',
        //         watermark_alpha: '0.07',
        //         watermark_x_space: 50,
        //         watermark_y_space: 10
        //       })
        //     }, 800)
        //   })
        // }
      }
    }
  },
  async mounted() {
    if (this.$route && this.$route.path === '/login') return
    await this.checkFirstLogin()
  },
  methods: {
    async checkFirstLogin() {
      try {
        // 只用已登录用户信息，未登录不查
        const username =
          store.getters.userInfo?.userName ||
          store.getters.userInfo?.realName ||
          ''

        if (!username) return

        const response = await getUserInfoFlag({ model: username })
        const raw = response && response.data
        const pwdFlag =
          (raw && raw.pwdFlag) ??
          (raw && raw.data && raw.data.pwdFlag) ??
          (raw && raw.result && raw.result.pwdFlag)

        // console.log('pwdFlag=>', pwdFlag, 'raw=>', raw)

        const onPersonal = this.$route.path && this.$route.path.startsWith('/personal')
        this.showFirstLoginModal = Number(pwdFlag) === 0 && !onPersonal
      } catch (error) {
        console.error('检查首次登录状态失败:', error)
      }
    },

    goToChangePassword() {
      this.$router.push('/personal')
      this.showFirstLoginModal = false
    }
  }
}
</script>

<style lang="scss">
body {
  font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-size: 12px;
}

// html::-webkit-scrollbar, body::-webkit-scrollbar
div::-webkit-scrollbar,
span::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  //background: #f1f2f3;
  cursor: pointer !important;
}

::-webkit-scrollbar-thumb {
  background: #9999 !important;
  border-radius: 10px;
}
</style>
